import { render } from "./Cuestionarios.vue?vue&type=template&id=61142a6e"
import script from "./Cuestionarios.vue?vue&type=script&lang=js"
export * from "./Cuestionarios.vue?vue&type=script&lang=js"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__